import React, { useEffect } from 'react';
import { ApiAuth } from '../../api/auth';
import { setUser } from '../../redux/auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { StyledLogin } from './styled';
import FormLogin from '../../forms/FormLogin';
import Logo from '../../components/Logo';
import { makeStyles } from '../../utils/styles';
import { paths } from '../../routes';
import { useApi } from '../../hooks/useApi';

const useStyles = makeStyles((css) => ({
    logo: css`
        margin-bottom: 50px;
    `,
}));

const Login = () => {
    const styles = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);

    //Setup request
    const [{ loading: loginLoading }, login] = useApi(ApiAuth.login, { manual: true });

    //Call request
    const handleSubmit = async (data) => {
        const res = await login(data)
        if (res?.data) {
            dispatch(setUser(res.data));
            history.push(paths.jobs);
        }
    };

    //redirect when user is logged in
    useEffect(() => {
        if (user?.jwt) {
            history.push(paths.jobs);
        }
    }, [user, history]);

    return (
        <StyledLogin>
            <Logo
                variant="white"
                customStyle={styles.logo}
            />
            <FormLogin
                loading={loginLoading}
                onSubmit={handleSubmit}
            />
        </StyledLogin>
    )
}

export default Login;
